import { Button, Checkbox, Input } from 'antd';
import { FormattedMessage } from 'react-intl';

import ProfileCard from '../../components/Cards/ProfileCard';
import ChangePassword from '../../components/ChangePassword/ChangePassword';
import Icon from '../../components/Icon/Icon';

import styles from './UserSettings.module.scss';

import { useUserSettings } from './useUserSettings';

const UserSettings = () => {
  const { setEmail, state, toggleEditEmail, togglePasswordPopup, updateEmail, updateSettings } = useUserSettings();
  const { contactOptions, currentUser, editEmail, email, showPasswordPopup } = state;

  return <div className={styles.pageContainer}>

    <div className={`${styles.pageSider} ${styles.topBorder} ${styles.noPadding}`}>
      {currentUser && <ProfileCard
        fitContainer
        showData
        data={{
          education: currentUser?.education,
          imageId: currentUser?.imageId,
          location: currentUser?.location,
          name: `${currentUser?.firstName} ${currentUser?.lastName}`,
          pronouns: currentUser?.pronouns,
          researchAreas: currentUser?.researchAreas,
        }}
      />
    }
    </div>

    <div className={styles.pageContent}>
      <div className={`${styles.mobileTopper} ${styles.topBorder} ${styles.noPadding}`}>
        {currentUser && <ProfileCard
            fitContainer
            showData
            data={{
              education: currentUser?.education,
              imageId: currentUser?.imageId,
              location: currentUser?.location,
              name: `${currentUser?.firstName} ${currentUser?.lastName}`,
              pronouns: currentUser?.pronouns,
              researchAreas: currentUser?.researchAreas,
            }}
          />}
      </div>
      <div className={styles.mainActions}>
        <div className={styles.breadcrumbs}>
          <span>{currentUser?.firstName} {currentUser?.lastName}</span>
          <b><span><FormattedMessage id="navigation.userSettings" /></span></b>
        </div>
      </div>
      <div className={styles.content}>
        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="envelope" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.email" /></h2>
          </div>
          <div className={styles.categoryContent}>
            {!editEmail ? <>
              <p>{email}</p>
              <Button type="link" onClick={toggleEditEmail}><FormattedMessage id="buttons.edit" /></Button>
            </> :
              <>
                <Input defaultValue={email} onChange={(event) => {
                  setEmail(event.target.value);
                }} />
                <Button type="link" onClick={() => { updateEmail(); toggleEditEmail(); }}><FormattedMessage id="buttons.save" /></Button>
              </>}
          </div>
        </div>
        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="lock" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.password" /></h2>
          </div>
          <div className={styles.categoryContent}>
            <Button type="link" onClick={togglePasswordPopup}>
              <FormattedMessage id="buttons.changePassword" />
            </Button>
          </div>
        </div>
        <div className={styles.category}>
          <div className={styles.categoryTitle}>
            <Icon name="phone" type="solid" color="light" width="16px" height="16px" />
            <h2><FormattedMessage id="userSettings.contactOptions" /></h2>
          </div>
          {contactOptions && <div className={styles.categoryContent}>
            <div className={styles.contactCheckbox}>

              <Checkbox className="contactCheckbox" name="allowSearch" checked={contactOptions?.includeInSearch} onChange={(event) => {
                updateSettings({ ...contactOptions, includeInSearch: event.target.checked });
              }}>
                <FormattedMessage id="userSettings.allowSearch" />
              </Checkbox>
            </div>
            <div className={styles.contactCheckbox}>
              <Checkbox className="contactCheckbox" name="allowNetwork" checked={contactOptions?.includeInNetwork} onChange={(event) => {
                updateSettings({ ...contactOptions, includeInNetwork: event.target.checked })
              }}>
                <FormattedMessage id="userSettings.allowNetwork" />
              </Checkbox>
            </div>
          </div>}
        </div>
      </div>
    </div>
    {showPasswordPopup && <ChangePassword onClose={togglePasswordPopup} />}
  </div>
}

export default UserSettings;